import * as ST from '@r1-frontend/ui-react/components/loaders/Throbber/styled';

export type TBlockAnimation = Partial<{ name: string }>;

export interface IProps {
    waitStatus?: boolean,
    position?: string,
    color?: string,
    className?: string,
    isLoading?: boolean,
    animation?: TBlockAnimation,
    size?: number,
    withoutTop?: boolean,
}

const Throbber = ({
    waitStatus,
    position,
    color,
    className,
    isLoading,
    animation,
    size = 1,
    withoutTop,
}: IProps) => {
    return (
        <ST.Wrapper
            hide={waitStatus}
            position={position}
            className={className}
            size={size}
            withoutTop={withoutTop}
        >
            {[ST.FirstBlock, ST.SecondBlock, ST.ThirdBlock].map(
                (Element, index) => (
                    <Element
                        key={index}
                        bgColor={color}
                        isLoading={isLoading}
                        animation={animation}
                    />
                ),
            )}
        </ST.Wrapper>
    );
};

export default Throbber;
